import _ from 'lodash';
import roles from 'app/validators/roles';

function canEditDocuments(model) {
  const userRole = _.get(model, 'session.role');
  return roles.ADMIN_ROLES.indexOf(userRole) >= 0;
}

function canShowHeader(model) {
  const userRole = _.get(model, 'session.role');
  return roles.ADMIN_ROLES.indexOf(userRole) >= 0;
}

const permissions = {
  'documents.editDocuments': [canEditDocuments],
  'documents.showHeader': [canShowHeader],
};

export default permissions;



// WEBPACK FOOTER //
// ./src/modules/documents/validators/action-validators.js